import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Line } from 'react-chartjs-2';

function LineChart(props) {

    let history = useHistory();
    let tempData = []
    let labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let userAllData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    let userActiveData = new Array(12).fill(0)
    let userPendingData = new Array(12).fill(0)
    let dataSetLabels = ['Active List', 'Canceled and Expired List']
    const [userListData, setUserListData] = useState([])
    let yStepSize = 0


    const userListDataClick = tempData => {
        history.push({
            pathname: '/userSubscriptionList',
            state: { data: tempData }
        })
    }

    if (props.data && props.data.length !== 0) {
        tempData = props.data
        let largest = 0
        const tempData2 = tempData.map(data => {
            let findIndex = labels.indexOf(data.period);
            let totalPastDue = 0
            if (data.all !== null) userAllData[findIndex] = data.all
            if (data.active !== null) userActiveData[findIndex] = data.active
            if (data.pending !== null) totalPastDue = data.pending
            if (data.expired !== null) totalPastDue = totalPastDue + data.expired
            if (data.canceled !== null) totalPastDue = totalPastDue + data.canceled
            userPendingData[findIndex] = totalPastDue
            return (
                null
            )
        })

        for (let i = 0; i <= userAllData.length; i++) {
            if (userAllData[i] > largest) {
                largest = userAllData[i];
            }
        }
        yStepSize = largest / 4
    }

    const userSubscriptionData = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [{
            label: 'Active List',
            data: userActiveData,
            lineTension: 0,
            borderJoinStyle: 'round',
            fill: false,
            borderColor: '#254117',
            borderWidth: 2,
            pointBackgroundColor: 'white'
        },
        {
            label: 'Canceled and Expired List',
            data: userPendingData,
            lineTension: 0,
            borderJoinStyle: 'round',
            fill: false,
            borderColor: '#966F33',
            borderWidth: 2,
            pointBackgroundColor: 'white'
        }
        ],
    };

    return (
        <div>
            <Line
                height='190'
                data={userSubscriptionData}
                options={{
                    onClick: function (e) {
                        let linePoint = this.getElementAtEvent(e)[0];
                        if (linePoint) {
                            let month = labels[linePoint._index];
                            let monthData = tempData.filter(data => data.period === month)
                            let datasetIndex = linePoint._datasetIndex;
                            if (monthData.length === 0) setUserListData([])
                            if (datasetIndex === 0 && monthData.length !== 0) {
                                let tempData = []
                                if (monthData[0].activeList !== null) tempData = monthData[0].activeList.map(data => ({ ...data, subscriptionStatus: 'Active' }))
                                setUserListData(tempData)
                                userListDataClick(tempData);
                            }
                            if (datasetIndex === 1 && monthData.length !== 0) {
                                let tempData = []
                                if (monthData[0].pendingList !== null) tempData = monthData[0].pendingList.map(data => ({ ...data, subscriptionStatus: 'Pending' }))
                                if (monthData[0].canceledList !== null) tempData = [...tempData, ...monthData[0].canceledList.map(data => ({ ...data, subscriptionStatus: 'Cancelled' }))]
                                if (monthData[0].expiredList !== null) tempData = [...tempData, ...monthData[0].expiredList.map(data => ({ ...data, subscriptionStatus: 'Expired' }))]
                                setUserListData(tempData)
                                userListDataClick(tempData);
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            display: false,
                        }
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false,
                            },
                        }],
                        yAxes: [{
                            ticks: {
                                min: 0,
                                stepSize: Math.round(yStepSize),
                                callback: function (value) { if (value % 1 === 0) { return value; } }
                            }
                        }]
                    },
                    tooltips: {
                        custom: function (tooltip) {
                            if (!tooltip) return;
                            tooltip.displayColors = false;
                        },
                        callbacks: {
                            label: function (tooltipItem, data) {
                                return ['', `${dataSetLabels[tooltipItem.datasetIndex]} : ${tooltipItem.yLabel}`]
                            }
                        }
                    }
                }} />
        </div>
    )

}

export default LineChart